// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"90a2a365","318":"b430bb18","537":"2b4c38a7","787":"0f4de03e","951":"8ddb5212"}[chunkId] + ".chunk.js";
};